import { createFileRoute } from "@tanstack/react-router"

import { AssetTypeSettingsAttachmentsView } from "../../../../../../../../views/AssetTypeSettingsAttachmentsView/AssetTypeSettingsAttachmentsView"
import { assetTypeAttachmentsViewStaticData } from "../../../../../../../../views/AssetTypeSettingsAttachmentsView/constants"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/attachments",
)({
	component: AssetTypeSettingsAttachmentsView,
	staticData: assetTypeAttachmentsViewStaticData,
})
